module.exports = __webpack_public_path__ + "img/vo-800.3af226b2.jpg";